import { ShippingCosts as RestShippingCosts } from '@itsrever/returns-api-types'
import DeliveryIcon from '@/app/refund-methods/v1/refund-card/delivery-icon'
import { formatStringPrice } from '@/utils'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/redux/hooks'
import { useTranslate } from '@/hooks'

interface ShippingCostsProps {
  shippingCosts?: RestShippingCosts
  isInstantMethod?: boolean
  hideMinimumReturnCost?: boolean
}
export const ShippingCosts: React.FC<ShippingCostsProps> = ({
  shippingCosts,
  isInstantMethod = false,
  hideMinimumReturnCost = false
}) => {
  const { t, i18n } = useTranslation()
  const { translate } = useTranslate()
  const lang = i18n.language
  const freeCosts = parseFloat(shippingCosts?.max?.amount || '0') === 0
  const freeAvailable = parseFloat(shippingCosts?.min?.amount || '0') === 0
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  if (freeCosts || (freeAvailable && isInstantMethod)) {
    return <></>
  }
  const equals =
    parseFloat(shippingCosts?.min?.amount || '0') ===
    parseFloat(shippingCosts?.max?.amount || '0')

  const minShippingCost = formatStringPrice(
    shippingCosts?.min?.amount,
    shippingCosts?.min?.currency,
    lang
  )
  const maxShippingCost = formatStringPrice(
    shippingCosts?.max?.amount,
    shippingCosts?.max?.currency,
    lang
  )

  const isHoff = settings.ecommerce_group == 'hoff'

  if (isHoff) {
    return (
      <div className="mt-1">
        <span className="flex items-center text-xs text-neutral-400">
          {translate('return_shipping_cost')}{' '}
          {equals ? (
            <>{minShippingCost}</>
          ) : (
            <>
              {hideMinimumReturnCost ? (
                <>
                  {t('refund_card.up_to')} {maxShippingCost}{' '}
                </>
              ) : (
                <>
                  {t('refund_card.from')} {minShippingCost}{' '}
                  {t('refund_card.up_to')} {maxShippingCost}
                </>
              )}
            </>
          )}
          <DeliveryIcon />
        </span>
      </div>
    )
  }

  const isMisako = settings.ecommerce_group == 'misako'

  if (isMisako) {
    return (
      <div className="mt-1">
        <span className="flex items-center text-xs font-[300] tracking-wider text-neutral-400">
          {translate('return_shipping_cost')}{' '}
          {equals ? (
            <>{minShippingCost}</>
          ) : (
            <>
              {hideMinimumReturnCost ? (
                <>
                  {t('refund_card.up_to')}{' '}
                  <span className="-mt-0.5 ml-1 text-red-400">
                    {maxShippingCost}
                  </span>
                </>
              ) : (
                <>
                  {t('refund_card.from')} {minShippingCost}{' '}
                  {t('refund_card.up_to')} {maxShippingCost}
                </>
              )}
            </>
          )}
        </span>
      </div>
    )
  }

  return (
    <div className="mt-1">
      <span className="flex items-center text-xs text-grey-2">
        {translate('return_shipping_cost')}{' '}
        {equals ? (
          <>{minShippingCost}</>
        ) : (
          <>
            {hideMinimumReturnCost ? (
              <>
                {t('refund_card.up_to')} {maxShippingCost}{' '}
              </>
            ) : (
              <>
                {t('refund_card.from')} {minShippingCost}{' '}
                {t('refund_card.up_to')} {maxShippingCost}
              </>
            )}
          </>
        )}
        <DeliveryIcon />
      </span>
    </div>
  )
}
export default ShippingCosts
